import { Link } from "react-router-dom";
import { Bot } from "lucide-react";

// Smooth-scroll to an in-page section without polluting the URL with a hash.
const scrollToSection = (e, id) => {
  e.preventDefault();
  document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
};

export const Navbar = () => (
  <header className="sticky top-12 z-40 bg-white/80 backdrop-blur-md border-b border-gray-200">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between">
      <Link to="/" data-testid="navbar-logo" className="flex items-center gap-2">
        <span className="w-9 h-9 rounded-lg bg-blue-600 flex items-center justify-center">
          <Bot className="w-5 h-5 text-white" />
        </span>
        <span className="font-heading font-bold text-xl text-gray-900">
          AI Central
        </span>
      </Link>
      <nav className="hidden md:flex items-center gap-8 text-sm font-semibold text-gray-600">
        <a href="#client-journey" onClick={(e) => scrollToSection(e, "client-journey")} data-testid="nav-how-it-works" className="hover:text-gray-900 transition-colors">How It Works</a>
        <a href="#live-matches" onClick={(e) => scrollToSection(e, "live-matches")} data-testid="nav-live-matches" className="hover:text-gray-900 transition-colors">Live Matches</a>
        <a href="#testimonials" onClick={(e) => scrollToSection(e, "testimonials")} data-testid="nav-testimonials" className="hover:text-gray-900 transition-colors">Testimonials</a>
      </nav>
      <Link
        to="/confirmation"
        data-testid="navbar-cta-btn"
        className="inline-flex items-center bg-gray-900 hover:bg-gray-800 text-white text-sm font-bold px-5 py-2.5 rounded-full transition-all duration-200 hover:scale-105"
      >
        Activate
      </Link>
    </div>
  </header>
);
